import {Injectable} from '@angular/core';
import {Subject} from "rxjs";

export interface AlertMessage {
    text: string;
    type: MessageType;
    id?: number;
    alertOptions?: {
        timeout?: number;
        closable?: boolean;
    };
    showAdditionalModal?: boolean;
}

export type MessageType = 'success' | 'error' | 'warning' | 'info';

@Injectable()
export class EventMessageBusService {
    private id = 0;

    constructor() {}

    public newMessagePosted$ = new Subject<AlertMessage>();

    public messageTimeout$ = new Subject<{ id: number }>();

    public postMessage(newMessage: AlertMessage) {
        this.id += 1;
        newMessage.id = this.id;
        if (!newMessage.alertOptions) {
            newMessage.alertOptions = {};
        }

        if (newMessage.alertOptions?.closable === undefined) {
            newMessage.alertOptions.closable = true;
        }

        if (newMessage.alertOptions?.timeout) {
           const timeout = setTimeout(() => {
               this.messageTimeout$.next({ id: <number>newMessage.id });
           }, newMessage.alertOptions.timeout)
        }
        this.newMessagePosted$.next(newMessage);
    }


}
